function customizeDropdown() {
  // Select the dropdown
  const dropdown = document.querySelector('.rc-selling-plans-dropdown__select');

  // Check if the dropdown exists and isn't already wrapped
  if (dropdown && !dropdown.parentNode.classList.contains('custom-dropdown')) {
    // Create the wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-dropdown';

    // Insert the wrapper before the dropdown
    dropdown.parentNode.insertBefore(wrapper, dropdown);

    // Move the dropdown inside the wrapper
    wrapper.appendChild(dropdown);

    // Apply custom styles dynamically (if not already added)
    if (!document.getElementById('custom-dropdown-styles')) {
      const style = document.createElement('style');
      style.id = 'custom-dropdown-styles';
      style.textContent = `
        .custom-dropdown {
          position: relative;
          display: inline-block;
        }
        .custom-dropdown select {
          width: 100%;
          padding-right: 30px;
        }
        .custom-dropdown::after {
          content: '▼' !important; /* Unicode arrow */
          font-size: 12px;
          color: #333;
          position: absolute;
          right: -35px;
          top: 36px;
          transform: translateY(-50%);
          pointer-events: none;
        }
      `;
      document.head.appendChild(style);
    }
  }
}

function moveSellingPlans() {
  const sellingPlans = document.querySelector('.rc-selling-plans');
  const radioLabel = document.querySelector('.rc-radio__label');

  // Move the selling plans if elements exist
  if (sellingPlans && radioLabel && !sellingPlans.classList.contains('moved')) {
    radioLabel.parentNode.insertBefore(sellingPlans, radioLabel.nextSibling);
    sellingPlans.classList.add('moved'); // Prevent duplicate moves
  }
}

// Observe DOM changes
const observer = new MutationObserver(() => {
  customizeDropdown();
  moveSellingPlans();
});

// Start observing the body for changes
observer.observe(document.body, { childList: true, subtree: true });

// Initial call (in case elements are already loaded)
setTimeout(() => {
  customizeDropdown();
  moveSellingPlans();
}, 2500); // Delay of 2.5 seconds for initial render

  setTimeout(() => {
  // Select the .rc-radio__label element
  const radioLabel = document.querySelector('.rc-selling-plans');

  // Check if the radioLabel exists
  if (radioLabel) {
    // Create a new <p> tag for "Benefits"
    const benefitsP = document.createElement('p');
    benefitsP.textContent = 'Benefits:'; // Set the text
    benefitsP.style.fontWeight = 'bold'; // Make it bold
    benefitsP.style.fontSize = '18px'; // Set font size
    benefitsP.style.marginTop = '8px'; // Add spacing for better layout
    benefitsP.id = 'recharge-benefits-heading'; // Add the ID

    // Insert the new <p> tag after the .rc-radio__label
    radioLabel.parentNode.insertBefore(benefitsP, radioLabel.nextSibling);

     // Add a CSS style block dynamically for ::before
    const style = document.createElement('style');
    style.textContent = `
      #recharge-benefits-heading::before {
        content: none; /* Ensures ::before content is not displayed */
      }
    `;
    document.head.appendChild(style);
  }
    
}, 2750); // Delay of 2.75 seconds


document.addEventListener('DOMContentLoaded', () => {
    const interval = setInterval(() => {
        // Select the label element with the for="rc-radio1" attribute
        const label = document.querySelector('label[for="rc-radio1"]');
        
        if (label) {
            // Trigger a click event on the label
            label.click();

            // Clear the interval once the element is found and clicked
            clearInterval(interval);
        }
    }, 100); // Check every 100 milliseconds
});